import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/product/:id',
      name: 'ProductId',
      meta: {
        title: '手机详情'
      },
      component: resolve => require(['@/containers/Product'], resolve)
    }, {
      path: '/assess',
      name: 'Assess',
      meta: {
        title: '估价详情'
      },
      component: resolve => require(['@/containers/Assess'], resolve)
    }, {
      path: '/account',
      name: 'Account',
      meta: {
        title: '财务记录'
      },
      component: resolve => require(['@/containers/Account'], resolve)
    }, {
      path: '/receipt',
      name: 'Receipt',
      meta: {
        title: '绑定收款方式'
      },
      component: resolve => require(['@/containers/Receipt'], resolve)
    }, {
      path: '/article/:id',
      name: 'article-id',
      meta: {
        title: '文章详情'
      },
      component: resolve => require(['@/containers/Article/_id'], resolve)
    }, {
      path: '/done',
      name: 'Done',
      meta: {
        title: '提交成功'
      },
      component: resolve => require(['@/containers/Done'], resolve)
    }, {
      path: '/user',
      name: 'User',
      meta: {
        title: '用户中心'
      },
      component: resolve => require(['@/containers/User'], resolve)
    }, {
      path: '/checkout',
      name: 'Checkout',
      meta: {
        title: '提交订单'
      },
      component: resolve => require(['@/containers/Checkout'], resolve)
    }, {
      path: '/order/:id',
      name: 'order-id',
      meta: {
        title: '订单详情'
      },
      component: resolve => require(['@/containers/Order/detail'], resolve)
    }, {
      path: '/bonus',
      name: 'Bonus',
      meta: {
        title: '增值券列表'
      },
      component: resolve => require(['@/containers/Bonus'], resolve)
    }, {
      path: '/login',
      name: 'Login',
      meta: {
        title: '登录'
      },
      component: resolve => require(['@/containers/Login'], resolve)
    }, {
      path: '/test',
      name: 'Test',
      meta: {
        title: '登录'
      },
      component: resolve => require(['@/containers/Test'], resolve)
    }, {
      path: '/oldnew',
      name: 'Oldnew',
      meta: {
        title: '以旧换新订单'
      },
      component: resolve => require(['@/containers/Oldnew'], resolve)
    }, {
      path: '/oldnew/:id',
      name: 'OldnewId',
      meta: {
        title: '以旧换新订单详情'
      },
      component: resolve => require(['@/containers/Oldnew/detail'], resolve)
    },
    {
      path: '*',
      meta: {
        title: '404'
      },
      component: resolve => require(['@/containers/404'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js